import React from "react";
import Navbar from "../components/layout/Navbar";
import Reveal from "../components/common/Reveal";
import Footer from "../components/layout/Footer";
import { BLOG_POSTS } from "../data/blogs";


const BlogsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-primary">
      <Navbar />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-primary via-accentGold/5 to-accentNavy/10 py-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-accentNavy/20 via-transparent to-accentGold/15" />
        <div className="absolute -right-32 top-1/2 h-96 w-96 rounded-full bg-accentGold/30 blur-3xl" />
        <div className="absolute -left-32 bottom-1/4 h-96 w-96 rounded-full bg-accentNavy/20 blur-3xl" />

        <div className="relative z-10 mx-auto max-w-6xl px-6 lg:px-10">
          <Reveal className="text-center space-y-6">
            <p className="text-xs uppercase tracking-[0.35em] text-accentNavy/45 font-semibold">
              Learn & Grow
            </p>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl text-accentNavy">
              Blogs & Articles
            </h1>
            <p className="mx-auto max-w-2xl text-lg text-accentNavy/70 leading-relaxed">
              Tips, tutorials, and insights to help you on your ukulele journey
            </p>
          </Reveal>
        </div>
      </section>

      {/* Blogs Grid */}
      <section className="relative bg-gradient-to-b from-primary via-primary/95 to-primary/90 py-20">
        <div className="absolute inset-x-0 top-0 h-20 bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.45),_transparent_60%)]" />
        <div className="absolute inset-x-0 bottom-0 h-32 bg-[radial-gradient(circle_at_bottom,_rgba(255,255,255,0.25),_transparent_65%)]" />

        <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {BLOG_POSTS.map((blog, index) => (
              <Reveal key={blog.id} delay={index * 80}>
                <article className="group relative flex h-full flex-col rounded-3xl border border-white/50 bg-white/90 overflow-hidden shadow-[0_20px_50px_-30px_rgba(9,32,63,0.3)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_25px_60px_-25px_rgba(9,32,63,0.4)]">
                  {blog.image && (
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={blog.image}
                        alt={blog.title}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-accentNavy/40 to-transparent" />
                    </div>
                  )}
                  <div className="flex flex-1 flex-col p-6">
                    <div className="mb-3 flex items-center gap-3">
                      <span className="rounded-full border border-accentNavy/20 bg-accentNavy/5 px-3 py-1 text-xs font-semibold uppercase tracking-[0.15em] text-accentNavy/70">
                        {blog.category}
                      </span>
                      <span className="text-xs text-accentNavy/50">{blog.readTime}</span>
                    </div>
                    <h2 className="mb-3 text-xl font-semibold text-accentNavy leading-tight group-hover:text-accentGold transition-colors duration-300">
                      {blog.title}
                    </h2>
                    <p className="mb-4 flex-1 text-sm text-accentNavy/70 leading-relaxed">
                      {blog.excerpt}
                    </p>
                    <div className="flex items-center justify-between border-t border-accentNavy/10 pt-4">
                      {/* <div>
                        <p className="text-xs font-semibold text-accentNavy">{blog.author}</p>
                        <p className="text-xs text-accentNavy/50">
                          {new Date(blog.date).toLocaleDateString("en-US", {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                          })}
                        </p>
                      </div> */}
                      <a
                        href={`#blog-detail?id=${blog.id}`}
                        className="rounded-full border border-accentNavy/20 bg-white/80 px-4 py-2 text-xs font-semibold uppercase tracking-[0.15em] text-accentNavy transition-all duration-300 hover:border-accentGold hover:bg-accentGold hover:text-white inline-block"
                      >
                        Read More
                      </a>
                    </div>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogsPage;

